import { render, staticRenderFns } from "./changePrice.vue?vue&type=template&id=338e7744&"
import script from "./changePrice.vue?vue&type=script&lang=js&"
export * from "./changePrice.vue?vue&type=script&lang=js&"
import style0 from "./changePrice.vue?vue&type=style&index=0&id=338e7744&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports